import { upsertSDSCollectionItem } from 'mini-sds-gateway/lib/services/upsertSDSCollectionItem';
import {
    BXUserCustomPropertiesCollection,
    NotificationEnabledKey,
    BXCustomPropertiesDataKey,
    NotificationSettingItemClass,
} from '../utils/constants';

export async function setNotificationEnabled(enablePushNotification: boolean) {
    return await upsertSDSCollectionItem(
        BXUserCustomPropertiesCollection,
        NotificationSettingItemClass,
        {
            [BXCustomPropertiesDataKey]: {
                [NotificationEnabledKey]: enablePushNotification,
            },
        }
    );
}
